import Edit from './Edit';
import List from './List';
import Show from './Show';

export { Edit, List, Show }
export default { Edit, List, Show }
